import React from 'react';
import { Award } from 'react-feather';
import {
  InlineShell,
  InlineEyebrow,
  CardButton,
  type F8CardData,
  type OnAction,
} from './cardHelpers';

interface Badge {
  id?: string;
  name?: string;
  description?: string;
  earned?: boolean;
  earnedAt?: any;
}

export default function BadgesCard({
  card,
  onAction,
}: {
  card: F8CardData;
  onAction?: OnAction;
}) {
  const data = card?.data || {};
  const badges: Badge[] = Array.isArray(data.badges) ? data.badges : [];
  const totalCount: number = data.totalCount || badges.length;
  const earnedCount = badges.filter((b) => b.earned).length;

  if (badges.length === 0) return null;

  return (
    <InlineShell>
      <InlineEyebrow label="badges" trailing={`${earnedCount} of ${totalCount} earned`} />

      <div className="f8c-badge-grid">
        {badges.map((badge, i) => {
          const earned = !!badge.earned;
          return (
            <div
              key={badge.id || i}
              title={badge.description || badge.name}
              className={`f8c-badge-tile${earned ? '' : ' f8c-badge-tile-locked'}`}
            >
              <div className="f8c-badge-medallion">
                <Award
                  size={22}
                  color={earned ? '#fff' : 'rgba(167,139,250,0.55)'}
                />
              </div>
              <div className="f8c-badge-name">{badge.name || 'Badge'}</div>
            </div>
          );
        })}
      </div>

      {totalCount > badges.length && (
        <div className="f8c-badge-actions">
          <CardButton
            small
            onClick={() => onAction?.({ action: 'navigate', params: { screen: 'UserProfile' } })}
          >
            View all badges
          </CardButton>
        </div>
      )}
    </InlineShell>
  );
}
